import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const SessionManager = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("LoginToken");

    if (token) {
      try {
        const decoded = jwtDecode(token); // Decodes the token to get `exp`
        const currentTimeInSeconds = (Date.now() / 1000);

        if (decoded.exp < currentTimeInSeconds) {
          // ✅ Token expired
          localStorage.removeItem("LoginToken");
          navigate("/login");
        }
      } catch (error) {
        console.log("Invalid token:", error);
        localStorage.removeItem("LoginToken");
        navigate("/login");
      }
    }
  }, [location]); // Triggered on route change

  return null;
};

export default SessionManager;
